import { configureStore } from '@reduxjs/toolkit'
import { loginReducer } from './slices/api/auth/loginSlice'
import { commonStateReducer } from './slices/common'
import { blogTypeReducer } from './slices/api/inner/blogTypeSlice'
import { bannerReducer } from './slices/api/inner/bannerSlice'
import { partnerReducer } from './slices/api/inner/partnerSlice'
import { userListReducer } from './slices/api/inner/userlistSlice'
import { teamMemberReducer } from './slices/api/inner/TeamMemberSlice'
import { memberReducer } from './slices/api/inner/MemberSlice'
import { blogsReducer } from './slices/api/inner/blogsSlice'
import { skillTypeReducer } from './slices/api/inner/skillTypeSlice'
import { skillsReducer } from './slices/api/inner/skillsSlice'
import { industriesReducer } from './slices/api/inner/industriesSlice'
import { jobsReducer } from './slices/api/inner/jobsSlice'
import { fontsReducer } from './slices/api/inner/fontsSlice'
import { statReducer } from './slices/api/inner/statSlice'
import { enquiryReducer } from './slices/api/inner/enquirySlice'
import { transactionReducer } from './slices/api/inner/transactionSlice'
import { cvReducer } from './slices/api/inner/cvSlice'
import { coverLetterReducer } from './slices/api/inner/coverLetter'
import { chatReducer } from './slices/api/inner/chatSlice'

export const store = configureStore({
    reducer: {
        loginUser: loginReducer,
        commonState: commonStateReducer,
        blogType: blogTypeReducer,
        banner: bannerReducer,
        partner: partnerReducer,
        userList: userListReducer,
        chat: chatReducer,
        teamMember: teamMemberReducer,
        member: memberReducer,
        blogs: blogsReducer,
        skillType: skillTypeReducer,
        skills: skillsReducer,
        industries: industriesReducer,
        jobs: jobsReducer,
        fonts: fontsReducer,
        stat: statReducer,
        enquiry: enquiryReducer,
        transaction: transactionReducer,
        cv: cvReducer,
        coverLetter: coverLetterReducer
    },
})